import {
  createStore,
  applyMiddleware,
  combineReducers,
  ReducersMapObject,
  Store,
  CombinedState,
  AnyAction,
} from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'

import { rootReducer } from './reducers'
import { initialState } from './initialState'
import { epicMiddleware, rootEpic } from './epics'
import { IStoreState } from './IStoreState'

let staticReducers: ReducersMapObject<IStoreState, any> = rootReducer

export const store = configureStore(initialState)

export function configureStore(
  initialState?: Partial<IStoreState>,
  extraReducers?: any,
  // for tests
  excludeEpics?: boolean
): Store<CombinedState<IStoreState>, AnyAction> & {
  dispatch: unknown;
} {
  // composeWithDevTools connects to the browser extension whenever it's present —
  // including on deployed web builds, where anyone with Redux DevTools installed
  // could inspect full app state and action payloads (e.g. login credentials).
  // Only wire it up in development.
  const epicEnhancer = applyMiddleware(epicMiddleware)
  const middlewares = !excludeEpics
    ? (process.env.NODE_ENV === 'development' ? composeWithDevTools(epicEnhancer) : epicEnhancer)
    : undefined

  const store = createStore(createReducer<IStoreState>(extraReducers), initialState, middlewares)

  return store
}

export function injectReducer(asyncReducer: ReducersMapObject<any, any>): void {
  staticReducers = {...staticReducers, ...asyncReducer}
  store.replaceReducer(combineReducers(staticReducers))
}

function createReducer<T>(asyncReducers: any = {}) {
  return combineReducers<T>({
    ...staticReducers,
    ...asyncReducers,
  })
}

epicMiddleware.run(rootEpic as any)

store.dispatch({
  type: 'APP_INIT',
})
